/**
 * index.tsx
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { FC }               from 'react';
import { useFormikContext } from 'formik';
import { Input }       from '~/components/input';
import { NumberInput } from '~/components/number';
import { Select }      from '~/components/select';
import { TypeSelect }  from '~/components/typeSelect';
import { styles }      from './styles';

export const TypeForm: FC = () => {
  const { values } = useFormikContext<any>();
  return (
    <div css={styles.container}>
      <div css={styles.types}>
        <TypeSelect name="propertyType" label="Immobilientyp" />
      </div>

      <div css={styles.form}>
        { values.propertyType === 'house' &&
          <div css={styles.columns}>
            <div css={styles.row}>
              <Select name="houseType" label="Art des Hauses">
                <option value="duplex">Doppelhaushälfte</option>
                <option value="row">Reihenhaus</option>
                <option value="single">Freistehend</option>
              </Select>
            </div>
          </div>
        }
        <div css={styles.columns}>
          <div css={styles.row}>
            <Input name="livingSpace" label="Wohnfläche" type="number" format="m²" />
          </div>
          { 
            values.propertyType === 'house' && (
              <div css={styles.row}>
                <Input name="propertySize" label="Grundstücksfläche" type="number" format="m²" />
              </div>
            )
          }
        </div>
        <div css={styles.columns}>
          <div css={styles.row}>
            <NumberInput name="numberOfRooms" label="Anzahl der Zimmer" step={.5} />
          </div>
          <div css={styles.row}>
            <NumberInput name="numberOfBathrooms" label="Anzahl der Bäder" step={.5} />
          </div>
        </div>
        <div css={styles.columns}>
          { values.propertyType === 'apartment' &&
            <div css={styles.row}>
              <NumberInput name="floor" label="Etage" />
            </div>
          }
          <div css={styles.row}>
            <NumberInput name="numberOfFloors" label="Anzahl der Etagen" />
          </div>
        </div>
        <div css={styles.columns}>
          <div css={styles.row}>
            <Input name="yearOfConstruction" label="Baujahr" type="number" placeholder="z.B. 1900" />
          </div>
        </div>
      </div>
    </div>
  );
};